/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeaturedStreamResponse } from './FeaturedStreamResponse';
import {
    FeaturedStreamResponseFromJSON,
    FeaturedStreamResponseFromJSONTyped,
    FeaturedStreamResponseToJSON,
    FeaturedStreamResponseToJSONTyped,
} from './FeaturedStreamResponse';
import type { StreamingMode } from './StreamingMode';
import {
    StreamingModeFromJSON,
    StreamingModeFromJSONTyped,
    StreamingModeToJSON,
    StreamingModeToJSONTyped,
} from './StreamingMode';

/**
 * Response shape returned by StreamingSettings.prepareForResponse(). Distinct from the StreamingSettings request/storage schema because featuredStreams here are FeaturedStreamResponse (string-typed addedBy, populated profileImageUrl).
 * @export
 * @interface StreamingSettingsResponse
 */
export interface StreamingSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof StreamingSettingsResponse
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StreamingSettingsResponse
     */
    allowParticipantStreams: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StreamingSettingsResponse
     */
    discoverableInLiveHub: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StreamingSettingsResponse
     */
    requireApproval: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StreamingSettingsResponse
     */
    showViewerCounts: boolean;
    /**
     * 
     * @type {number}
     * @memberof StreamingSettingsResponse
     */
    maxFeaturedStreams: number;
    /**
     * 
     * @type {StreamingMode}
     * @memberof StreamingSettingsResponse
     */
    streamingMode?: StreamingMode;
    /**
     * 
     * @type {Array<FeaturedStreamResponse>}
     * @memberof StreamingSettingsResponse
     */
    featuredStreams: Array<FeaturedStreamResponse>;
}



/**
 * Check if a given object implements the StreamingSettingsResponse interface.
 */
export function instanceOfStreamingSettingsResponse(value: object): value is StreamingSettingsResponse {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('allowParticipantStreams' in value) || value['allowParticipantStreams'] === undefined) return false;
    if (!('discoverableInLiveHub' in value) || value['discoverableInLiveHub'] === undefined) return false;
    if (!('requireApproval' in value) || value['requireApproval'] === undefined) return false;
    if (!('showViewerCounts' in value) || value['showViewerCounts'] === undefined) return false;
    if (!('maxFeaturedStreams' in value) || value['maxFeaturedStreams'] === undefined) return false;
    if (!('featuredStreams' in value) || value['featuredStreams'] === undefined) return false;
    return true;
}

export function StreamingSettingsResponseFromJSON(json: any): StreamingSettingsResponse {
    return StreamingSettingsResponseFromJSONTyped(json, false);
}

export function StreamingSettingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreamingSettingsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'allowParticipantStreams': json['allowParticipantStreams'],
        'discoverableInLiveHub': json['discoverableInLiveHub'],
        'requireApproval': json['requireApproval'],
        'showViewerCounts': json['showViewerCounts'],
        'maxFeaturedStreams': json['maxFeaturedStreams'],
        'streamingMode': json['streamingMode'] == null ? undefined : StreamingModeFromJSON(json['streamingMode']),
        'featuredStreams': ((json['featuredStreams'] as Array<any>).map(FeaturedStreamResponseFromJSON)),
    };
}

export function StreamingSettingsResponseToJSON(json: any): StreamingSettingsResponse {
    return StreamingSettingsResponseToJSONTyped(json, false);
}

export function StreamingSettingsResponseToJSONTyped(value?: StreamingSettingsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'allowParticipantStreams': value['allowParticipantStreams'],
        'discoverableInLiveHub': value['discoverableInLiveHub'],
        'requireApproval': value['requireApproval'],
        'showViewerCounts': value['showViewerCounts'],
        'maxFeaturedStreams': value['maxFeaturedStreams'],
        'streamingMode': StreamingModeToJSON(value['streamingMode']),
        'featuredStreams': ((value['featuredStreams'] as Array<any>).map(FeaturedStreamResponseToJSON)),
    };
}

